"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var field = {
  operators: [{
    value: '=',
    label: '='
  }, {
    value: '>',
    label: '>'
  }, {
    value: '<',
    label: '<'
  }, {
    value: '!=',
    label: '!='
  }, {
    value: '<=',
    label: '<='
  }, {
    value: '>=',
    label: '>='
  }],
  defaultOperator: '=',
  filter: function filter(rawValue, q) {
    var operator = q.operator,
        qv = q.value;

    if (qv !== '') {
      var queryValue = qv ? parseInt(qv.split(':').join('')) : 0;
      var value = rawValue ? parseInt(rawValue.split(':').join('')) : 0;

      switch (operator) {
        case '=':
          return value === queryValue;

        case '>':
          return value > queryValue;

        case '<':
          return value < queryValue;

        case '!=':
          return value !== queryValue;

        case '<=':
          return value <= queryValue;

        case '>=':
          return value >= queryValue;

        default:
          return false;
      }
    } else {
      return true;
    }
  },
  sort: function sort(orientation, aRaw, bRaw) {
    var a = new Date(aRaw).getTime();
    var b = new Date(bRaw).getTime();
    var result = a < b ? -1 : a > b ? 1 : 0;
    return result * orientation;
  },
  render: function render(_ref, _onChange) {
    var _ref$value = _ref.value,
        value = _ref$value === void 0 ? '' : _ref$value,
        _ref$isCaseSensitive = _ref.isCaseSensitive,
        isCaseSensitive = _ref$isCaseSensitive === void 0 ? false : _ref$isCaseSensitive;
    return /*#__PURE__*/_react.default.createElement(_TextField.default, {
      InputLabelProps: {
        shrink: true
      },
      inputProps: {
        step: 300 // 5 min

      },
      type: "time",
      value: value,
      onChange: function onChange(e) {
        return _onChange({
          value: e.target.value
        });
      }
    });
  }
};
var _default = field;
exports.default = _default;
module.exports = exports.default;